import { apiFetch } from './api';

export async function listRoles() {
  const res = await apiFetch('/api/admin/roles');
  return { data: res.data || [] };
}

export async function getRole(id) {
  const res = await apiFetch(`/api/admin/roles/${id}`);
  return { data: res.data };
}

export async function createRole(payload) {
  return apiFetch('/api/admin/roles', {
    method: 'POST',
    body: payload
  });
}

export async function updateRole(id, payload) {
  return apiFetch(`/api/admin/roles/${id}`, {
    method: 'PATCH',
    body: payload
  });
}

export async function deleteRole(id) {
  return apiFetch(`/api/admin/roles/${id}`, {
    method: 'DELETE'
  });
}





